export enum ModifierKeys {
  Alt = 'Alt',
  Control = 'Control',
  Meta = 'Meta',
  Shift = 'Shift',
  Ctrl_Meta = 'Ctrl_Meta',
}
